export default [
  {
    name: 'retaguarda',
    namespaced: true,
    state: {
      parceiros: [],
      onboardingContaHabilitado: false
    },
    mutations: {
      parceiros(state, array) {
        state.parceiros = array
      },
      LIMPAR_CHALLENGE() {
        localStorage.removeItem('challenge')
      },
      onboardingContaHabilitado(state, array) {
        state.onboardingContaHabilitado = array
      }
    },
    actions: {
      limparChallenge({ commit }) {
        commit('LIMPAR_CHALLENGE')
      }
    },
    getters: {
      parceiros(state) {
        if (localStorage.getItem('parceiros')) {
          state.parceiros = JSON.parse(localStorage.getItem('parceiros'))
        }
        return state.parceiros
      },
      onboardingContaHabilitado(state) {
        if (JSON.parse(localStorage.getItem('empresa')) && JSON.parse(localStorage.getItem('parceiros'))) {
          const parceiro = JSON.parse(localStorage.getItem('empresa'))
          const parceiros = JSON.parse(localStorage.getItem('parceiros'))

          state.onboardingContaHabilitado = parceiros.find(e => e.value === parceiro.codigo)?.onboardingContaHabilitado
        }
        return state.onboardingContaHabilitado
      }
    }
  }
]
